<template>
    <div id='footer'>
        <!-- footer -->
            <div class='row m-0 crow '>
                <div class='col-sm-12 footer bg-dark d-flex flex-column flex-lg-row'>
                    <div class="m-auto text-light text-center">
                        <h2> Made by <a href="https://instagram.com/ishanpsahota" class="text-warning"> Ishan Prasad </a> </h2>
                        <h3> Using MongoDB, Express, VueJS &amp; NodeJS </h3>
                    </div>
                </div>
            </div>
        <!-- footer end -->
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>